export default "__VITE_ASSET__e25a0c81__"